import { useHistory, useParams } from 'react-router-dom';

import Routes from 'config/routes';

import useSaveFrom from 'hooks/useSaveFrom';

import useAuthentication from 'domain/authentication/useAuthentication';

const useEditRecipePage = () => {
  const from = useSaveFrom('edit_recipe_from');
  const { isAuthenticated } = useAuthentication();
  const { id, step } = useParams();
  const history = useHistory();

  const recipeEditPageRouter = Routes.editRecipe(id);
  const menuRoute = recipeEditPageRouter();

  const goToMenuPage = () => history.push(menuRoute);

  const exitPage = () => history.push(from);

  return {
    id,
    step,
    exitPage,
    recipeEditPageRouter,
    goToMenuPage,
    isAuthenticated,
  };
};

export default useEditRecipePage;
